import {Vue} from "vue-property-decorator";
import moment from "moment/moment";

Vue.filter('formatDate', (value: string, format?: string) => moment(String(value)).format(format || 'DD-MM-YYYY'));
Vue.filter('fromNow', (value: string, withoutSuffix?: boolean) => moment(String(value)).fromNow(withoutSuffix));
